// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmit from '@stimulus-components/auto-submit'


application.register('auto-submit', AutoSubmit)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import HlsPlayerController from "./hls_player_controller"
application.register("hls-player", HlsPlayerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import TitleReviewController from "./title_review_controller"
application.register("title-review", TitleReviewController)
